export default {
  title: {
    en: 'Cool Avatar!',
    ar: 'شخصية رائعة!'
  },
  confirm: {
    en: 'Add this avatar to your family?',
    ar: 'هل تريد إضافة هذه الشخصية إلى عائلتك؟'
  },
  yes: {
    en: 'Add',
    ar: 'إضافة'
  },
  no: {
    en: 'Back',
    ar: 'عودة'
  }
};
